"use client";
import { IBaseLabelValue } from "@/interfaces";
import { CustomButton, FlexBetween, FlexCenter, FlexCol } from "@/components";
import { cn } from "@/lib";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import InputDataContent from "@/components/inquiryDetails/inputDataContent";
import { routes } from "@/routes";
import DownloadPdf from "../../pdfTemplates/downloadPdf";
import React, { useRef } from "react";
import ResultContent from "@/components/resultContent";
import PdfTemplate from "@/components/pdfTemplates/pdfTemplate";
import { IRawPurchasedCheckInquiryResData } from "@/interfaces/inquiries/chequeInquiry";

const MAP_CHECK_TYPE = {
  BANS: "chequeV2Inquiry.ban",
  CHD: "chequeV2Inquiry.chd",
  CHS: "chequeV2Inquiry.chs",
  CHT: "chequeV2Inquiry.cht",
} as const;

const ChequeInquiryDetails = ({
  data,
}: {
  data: IRawPurchasedCheckInquiryResData;
}) => {
  const t = useTranslations("serviceResponseDetails");
  const router = useRouter();
  const chequeData = data.data.data.data;
  const chequeInput = data.data.input;

  const inputContent: IBaseLabelValue[] = [
    {
      label: t("chequeInquiry.sayadId"),
      value: chequeInput.sayad_id,
    },
  ];
  const pdfContentRef = useRef<HTMLDivElement>(null);

  // const returnsCheque =
  //   chequeData.returned_cheques !== "" ? (
  //     <p className="text-sm md:text-base">
  //       براساس اطلاعات دریافتی از سامانه بانک مرکزی،صادر کننده چک
  //       <span className="mx-1 font-semibold" style={{ color: "#c10007" }}>
  //         &nbsp; دارای {chequeData.returned_cheques} فقره چک برگشتی ثبت‌شده
  //         می‌باشد
  //       </span>{" "}
  //       . توصیه می‌شود پیش از انجام هرگونه تعامل مالی، سوابق ایشان به‌صورت کامل
  //       بررسی گردد.
  //     </p>
  //   ) : (
  //     <p className="text-sm md:text-base">
  //       براساس بررسی‌های انجام‌شده
  //       <span className="mx-1 font-semibold" style={{ color: "#00a63e" }}>
  //         &nbsp;هیچ‌گونه سابقه‌ای از چک برگشتی&nbsp;
  //       </span>
  //       ،برای صادر کننده چک{chequeData.returned_cheques} در سامانه بانک مرکزی
  //       ثبت نشده است.
  //     </p>
  //   );

  const resultContent = [
    {
      label: t("chequeV2Inquiry.name"),
      value: chequeData.name || "-",
    },
    {
      label: t("chequeV2Inquiry.iban"),
      value: chequeData.iban || "-",
    },
    {
      label: t("chequeV2Inquiry.issue_date"),
      value: chequeData.issuedDate || "-",
    },
    {
      label: t("chequeV2Inquiry.expiration_date"),
      value:
        chequeData.expirationDate !== "null" ? chequeData.expirationDate : "-",
    },
    {
      label: t("chequeV2Inquiry.serial_no"),
      value: chequeData.serialNumber || "-",
    },
    {
      label: t("chequeV2Inquiry.series_no"),
      value: chequeData.seriesNumber || "-",
    },
    {
      label: t("chequeV2Inquiry.check_type"),
      value: t(MAP_CHECK_TYPE[chequeData.chequeType]),
    },
    {
      label: t("chequeV2Inquiry.branch_code"),
      value: chequeData.branchCode || "-",
    },
    // {
    //   label: t("chequeV2Inquiry.returned_cheques"),
    //   value: returnsCheque,
    // },
  ];

  return (
    <div className="shadow-main from-emerald-mint relative basis-[500px] rounded-2xl bg-linear-to-b to-transparent p-[2px] lg:basis-[640px]">
      <FlexCol className="items-stretch rounded-2xl bg-white p-8">
        <h2 className="mb-5 text-center font-bold lg:text-lg">
          استعلام چک صیادی
        </h2>
        <InputDataContent
          content={inputContent}
          className="le p-6 md:p-8"
          itemClassName="flex-col md:flex-row leading-9 md:leading-none"
        />
        <FlexBetween className="items-center md:mb-3">
          <h2 className="my-5 text-center text-lg font-bold md:my-0">
            {t("accountToIban.resultTitle")}
          </h2>
          <DownloadPdf
            id="Cheque_V2_Inquiry-inquiry-download-pdf"
            htmlContentRef={pdfContentRef}
            useHtmlToPdf={true}
            fileName={`استعلام-چک-صیادی-${chequeInput.sayad_id}`}
            tableTitle="استعلام-چک-صیادی"
          />
        </FlexBetween>
        <ResultContent content={resultContent} className="md:gap-4" />
        <FlexCenter className="flex flex-col justify-center md:flex-row md:gap-6">
          <DownloadPdf
            id="bounced-check-inquiry-download-pdf"
            htmlContentRef={pdfContentRef}
            useHtmlToPdf={true}
            fileName={`استعلام-چک-صیادی-${chequeInput.sayad_id}`}
            tableTitle="استعلام چک صیادی"
            className="order-2 flex cursor-pointer items-center justify-center rounded-md border-none! bg-red-700 px-8 py-[6px] text-white transition-all hover:bg-red-800 md:order-1 lg:rounded-lg lg:py-[8px]"
            showIcon={false}
            labelClass="text-xs lg:text-sm xl:text-base font-medium"
          />
          <div className="order-1 mb-4 flex gap-4 md:order-2 md:m-0 xl:gap-6">
            <CustomButton
              id="details-check-inquiry-back"
              className={cn("w-fit bg-gray-500")}
              onClick={() =>
                router.push(routes.main.INQUIRY_HISTORY.primaryPath)
              }
            >
              {t("companyInformationInquiry.backButton")}
            </CustomButton>
            <CustomButton
              id="details-check-inquiry-new-request"
              onClick={() =>
                router.push(routes.services.Cheque_V2_Inquiry.rewritePath)
              }
              className={cn("bg-primary-main mx-auto w-fit px-8! text-white")}
            >
              {t("newRequest")}
            </CustomButton>
          </div>
        </FlexCenter>
      </FlexCol>
      <div
        ref={pdfContentRef}
        style={{
          position: "fixed",
          left: "-9999px",
          top: "-9999px",
          width: "800px",
          fontFamily: "IRANYekan, sans-serif",
          margin: "2rem auto",
        }}
      >
        <PdfTemplate
          resultContent={resultContent}
          code={data.code}
          dateTime={data.created_at}
          tableTitle="استعلام چک صیادی"
        />
      </div>
    </div>
  );
};

export default ChequeInquiryDetails;
